import { Playground, Props } from 'docz';
import { ImageViewer, Button } from '@madup-inc/mad-design';
import * as React from 'react';
export default {
  Playground,
  Props,
  ImageViewer,
  Button,
  React
};